import CoreMessageDispatcher from './CoreMessageDispatcher';
import CoreEvents from '../events/CoreEvents';
import ChangeOrders from '../events/ChangeOrders';
import ComponentEvents from '../events/ComponentEvents';
import {SetReadyStatus} from '../actions/states/SetReadyStatus';
import {InitiateStates} from '../actions/states/InitiateStates';
import {GotoNewState} from '../actions/states/GotoNewState';
import {NavToNewState} from '../actions/states/NavToNewState';
import {SwipeToNewState} from '../actions/states/SwipeToNewState';
import {AutoplayToNewState} from '../actions/states/AutoplayToNewState';
import {CloseCurrentEvent} from '../actions/states/CloseCurrentEvent';
import {ExpandCurrentEvent} from '../actions/states/ExpandCurrentEvent';
import {CollapseCurrentEvent} from '../actions/states/CollapseCurrentEvent';
import {SwitchSoundOnOffState} from '../actions/states/SwitchSoundOnOffState';
import {FirstUserAction} from '../actions/states/FirstUserAction';
import {SwitchMenuState} from '../actions/states/SwitchMenuState';
import {OpenMenu} from '../actions/states/OpenMenu';
import {CloseMenu} from '../actions/states/CloseMenu';
import {CloseHelper} from '../actions/states/CloseHelper';
import {Transition3DStarted} from '../actions/states/Transition3DStarted';
import {Transition3DEnded} from '../actions/states/Transition3DEnded';
import {SetCoverAlmostIn} from '../actions/states/SetCoverAlmostIn';
import {SetCoverOut} from '../actions/states/SetCoverOut';
import {OpenEventCover} from '../actions/states/OpenEventCover';
import {TransitionEvtStarted} from '../actions/states/TransitionEvtStarted';
import {TransitionEvtEnded} from '../actions/states/TransitionEvtEnded';

const _dispatcher = CoreMessageDispatcher.instance();

const _init = ctrlr => {
    if (ctrlr.initiated) return ctrlr;

    _startMediators(ctrlr.firstLvlMediators);
    _addListeners(ctrlr.mapEvents);
    _dispatcher.once(CoreEvents.READY, ctrlr.start);

    ctrlr.initiated = true;
    return ctrlr;
};

const _start = ctrlr => {
    if (ctrlr.started) return ctrlr;

    _startMediators(ctrlr.secondLvlMediators);

    SetReadyStatus(true);

    ctrlr.started = true;
    return ctrlr;
};

const _startMediators = mdrs => {
    mdrs.forEach(mdr => mdr.start());
};

const _addListeners = mapEvents => {
    let evt;
    for (evt in mapEvents) {
        if (!mapEvents.hasOwnProperty(evt)) continue;

        _dispatcher.on(evt, mapEvents[evt]);
    }
};

const CoreController = (app, firstLvlMediators, secondLvlMediators = null) => {
    const ctrlr = {
        app: app,
        firstLvlMediators: firstLvlMediators,
        secondLvlMediators: secondLvlMediators,
        mapEvents: {}
    };

    // Orders
    ctrlr.mapEvents[ChangeOrders.GOTO_STATE] = GotoNewState;
    ctrlr.mapEvents[ChangeOrders.NAV_TO_STATE] = NavToNewState;
    ctrlr.mapEvents[ChangeOrders.SWIPE_TO_STATE] = SwipeToNewState;
    ctrlr.mapEvents[ChangeOrders.AUTPLAY_TO_STATE] = AutoplayToNewState;
    ctrlr.mapEvents[ChangeOrders.INITIATE_STATES] = InitiateStates;
    ctrlr.mapEvents[ChangeOrders.CLOSE_CURRENT_EVENT] = CloseCurrentEvent;
    ctrlr.mapEvents[ChangeOrders.EXPAND_CURRENT_EVENT] = ExpandCurrentEvent;
    ctrlr.mapEvents[ChangeOrders.COLLAPSE_CURRENT_EVENT] = CollapseCurrentEvent;
    ctrlr.mapEvents[ChangeOrders.SWITCH_SOUND_STATE] = SwitchSoundOnOffState;
    ctrlr.mapEvents[ChangeOrders.FIRST_USER_ACTION] = FirstUserAction;
    ctrlr.mapEvents[ChangeOrders.SWITCH_MENU_STATE] = SwitchMenuState;
    ctrlr.mapEvents[ChangeOrders.OPEN_MENU] = OpenMenu;
    ctrlr.mapEvents[ChangeOrders.CLOSE_MENU] = CloseMenu;
    ctrlr.mapEvents[ChangeOrders.CLOSE_HELPER] = CloseHelper;

    // Component reactions
    ctrlr.mapEvents[ComponentEvents.TRANSITION_3D_STARTED] = doThat => {
        SetCoverOut(doThat).then(Transition3DStarted);
    };
    ctrlr.mapEvents[ComponentEvents.TUNNEL_3D_AT_LOCATION] = SetCoverAlmostIn;
    ctrlr.mapEvents[ComponentEvents.TRANSITION_3D_ENDED] = doThat => {
        OpenEventCover(doThat).then(Transition3DEnded);
    };
    ctrlr.mapEvents[ComponentEvents.TRANSITION_STARTED] = TransitionEvtStarted;
    ctrlr.mapEvents[ComponentEvents.TRANSITION_ENDED] = TransitionEvtEnded;

    ctrlr.init = () => {
        return _init(ctrlr);
    };

    ctrlr.start = () => {
        return _start(ctrlr);
    };

    ctrlr.setSecondLvlMediators = secondLvlMediators => {
        ctrlr.secondLvlMediators = secondLvlMediators;
    };

    return ctrlr;
};

export {CoreController};
export default CoreController;
